import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { book } from '../model/book';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserLoggedInService {


  constructor(private http:HttpClient) { }

  addBook(book:book,customerId:number):Observable<string>{
  
    return this.http.post<string>("https://house-books1.herokuapp.com/book/book/"+customerId,book,{ responseType: 'text' as 'json' })
  }
}
